import React, { useState } from "react";
import styled from "styled-components";
// Components
import ProjectBox from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
// Assets
import ProjectImg1 from "../../assets/img/carousel/crossdocking.jpg";
import ProjectImg2 from "../../assets/img/carousel/hazmat.jpg";
import ProjectImg3 from "../../assets/img/carousel/finalmile.jpg";
import ProjectImg4 from "../../assets/img/carousel/coldstorage.jpg";
import ProjectImg5 from "../../assets/img/carousel/temperaturecontrolled.png";
import ProjectImg6 from "../../assets/img/carousel/fullfilment.PNG";
import AddImage2 from "../../assets/img/services.jpg";
import { Carousel } from "3d-react-carousal";

export default function Projects() {
  let slides = [
    <>
      <div className="heading-background">
        <h1>Cross-Docking</h1>
      </div>
      <img className="imageSize" src={ProjectImg1} alt="1" />
    </>,
    <>
      <div className="heading-background">
        <h1> Cold-Storage</h1>
      </div>
      <img className="imageSize" src={ProjectImg4} alt="1" />
    </>,
    <>
      <div className="heading-background">
        <h1>Hazmat</h1>
      </div>
      <img className="imageSize" src={ProjectImg2} alt="2" />
    </>,
    <>
      <div className="heading-background">
        <h1>Final Mile Delivery</h1>
      </div>
      <img className="imageSize" src={ProjectImg3} alt="3" />
    </>,
    <>
      <div className="heading-background">
        <h1>Order Fulfilment</h1>
      </div>
      <img className="imageSize" src={ProjectImg6} alt="4" />
    </>,
    <>
      <div className="heading-background">
        <h1>Temperature Controlled</h1>
      </div>
      <img className="imageSize" src={ProjectImg5} alt="5" />
    </>,
  ];

  return (
    <Wrapper id="projects">
      <div className="whiteBg ">
        <div
          className="container"
          style={{
            minHeight: "90vh",
          }}
        >
          <HeaderInfo>
            <h1 className="font40 extraBold">Services we provide</h1>
          </HeaderInfo>
          <div style={{ marginTop: "50px", height: "15em" }}>
            <Carousel slides={slides} autoplay={true} interval={300000} />
          </div>
        </div>
      </div>
      <div className="lightBg ">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AddLeftInner>
                <ImgWrapper className="flexCenter">
                  <img className="radius8" src={AddImage2} alt="add" />
                </ImgWrapper>
              </AddLeftInner>
            </AddLeft>
            <AddRight>
              <h4 className="font15 semiBold">A few words about company</h4>
              <h2 className="font40 extraBold">
                One Click And Choose Our Services
              </h2>
              <p className="font12">
                We are trusted by unlimited customer they trust our services to
                be secure, reliable and ensurity of package to be deliver.
              </p>
              <ButtonsRow
                className="flexNullCenter"
                style={{ margin: "30px 0" }}
              >
                <div style={{ width: "190px" }}>
                  <FullButton
                    title=" Get a Quote"
                    action={() => alert("clicked")}
                  />
                </div>
              </ButtonsRow>
            </AddRight>
          </Advertising>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;
